import { NoResults } from "../../components/NoResults/NoResults.js";
import { DateTime as DateTime$1 } from "../../components/DateTime/index.js";
import { REFS_LINK_TYPE_LABELS_MAP } from "./RefsByTypeTitles/constants.js";
import { RefLinkRefLabel } from "./RefLinkRefLabel.js";
import "react";
import { Icon, TableGroup } from "@therms/atalaya";
import { IoLink } from "react-icons/io5";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/shared/RefLinksTable.tsx
function RefLinksTable({ forRef, onClickRow, pagination, refLinksData }) {
	return /* @__PURE__ */ jsx("div", { children: refLinksData?.total ? /* @__PURE__ */ jsx(TableGroup, {
		onClickRow: ({ rowData }) => onClickRow?.(rowData.id),
		onSetRecordsPerPage: pagination.setRecordsPerPage,
		onSetSkippedRecords: pagination.setSkippedRecords,
		recordsPerPage: pagination.recordsPerPage,
		skippedRecords: pagination.skippedRecords,
		totalRecords: refLinksData?.total ?? 0,
		HeadRow: () => /* @__PURE__ */ jsxs(TableGroup.HeadRow, { children: [
			/* @__PURE__ */ jsx(TableGroup.HeadCell, { children: "Date" }),
			/* @__PURE__ */ jsx(TableGroup.HeadCell, { children: "Type" }),
			/* @__PURE__ */ jsx(TableGroup.HeadCell, { children: "Reason" }),
			/* @__PURE__ */ jsx(TableGroup.HeadCell, { children: " " })
		] }),
		data: refLinksData?.refLinks ?? [],
		keyProp: "id",
		Row: ({ rowData }) => {
			return /* @__PURE__ */ jsxs(TableGroup.Row, {
				className: classnames({ "cursor-pointer": !!onClickRow }, "hover:bg-surface-strong"),
				rowKey: rowData.id,
				children: [
					/* @__PURE__ */ jsx(TableGroup.Cell, {
						className: "align-top",
						children: /* @__PURE__ */ jsx(DateTime$1, { timestamp: rowData.linkedAt })
					}),
					/* @__PURE__ */ jsx(TableGroup.Cell, { children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("div", { children: rowData.refs.map((ref) => /* @__PURE__ */ jsxs("div", {
						className: "space-x-sm flex",
						children: [/* @__PURE__ */ jsx(Icon, {
							color: ref.value === rowData.controller.value || ref.value === rowData.controller?.redirectRef?.value ? "info" : "subtle",
							Icon: IoLink,
							size: "sm"
						}), /* @__PURE__ */ jsxs("div", { children: [
							/* @__PURE__ */ jsx("span", {
								className: "text-neutral font-light",
								children: REFS_LINK_TYPE_LABELS_MAP[ref.type]?.single ?? ref.type
							}),
							" ",
							/* @__PURE__ */ jsx(RefLinkRefLabel, {
								type: ref.type,
								value: ref.value
							})
						] })]
					}, ref.type + ref.value)) }) }) }),
					/* @__PURE__ */ jsx(TableGroup.Cell, {
						className: "align-top",
						children: rowData.reason
					}),
					/* @__PURE__ */ jsx(TableGroup.Cell, { children: " " })
				]
			});
		}
	}) : /* @__PURE__ */ jsx(NoResults, { text: "No Linked Records" }) });
}
//#endregion
export { RefLinksTable };

//# sourceMappingURL=RefLinksTable.js.map